import {
    CREATE_CHALLENGE_REQUESTED,
    CREATE_CHALLENGE_SUCCEEDED,
    CREATE_CHALLENGE_FAILED,
    CLEAR_CREATED_CHALLENGE,
    FEATURED_CHALLENGE_REQUESTED,
    FEATURED_CHALLENGE_SUCCEEDED,
} from './constants';

export function createChallengeRequested(requestedChallenge) {
    return {
        type: CREATE_CHALLENGE_REQUESTED,
        requestedChallenge,
    };
}

export function createChallengeSucceeded(challenge) {
    return {
        type: CREATE_CHALLENGE_SUCCEEDED,
        challenge,
    };
}

export function createChallengeFailed(error) {
    return {
        type: CREATE_CHALLENGE_FAILED,
        error,
    };
}

export function clearCreatedChallengeState() {
    return {
        type: CLEAR_CREATED_CHALLENGE,
    };
}

export function featuredChallengeRequested(search) {
    return {
        type: FEATURED_CHALLENGE_REQUESTED,
        search,
    };
}

export function featuredChallengeSucceeded(featuredChallenges) {
    return {
        type: FEATURED_CHALLENGE_SUCCEEDED,
        featuredChallenges,
    };
}
